var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMusicOff = function SvgMusicOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18463 16.001C4.87097 16.4555 4.2482 16.5698 3.79363 16.2561C3.33905 15.9425 3.22481 15.3197 3.53847 14.8651L13.406 0.564369C13.7196 0.109794 14.3424 -0.00444266 14.797 0.309214C15.2516 0.62287 15.3658 1.24564 15.0521 1.70022L14 3.22505L14 12C14 12.0661 13.9936 12.1307 13.9814 12.1932C13.9937 12.2938 14 12.3961 14 12.5C14 13.8807 12.8807 15 11.5 15C10.1193 15 9 13.8807 9 12.5C9 11.1193 10.1193 10 11.5 10C11.6712 10 11.8384 10.0172 12 10.05L12 6.1236L5.18463 16.001ZM0 12.5C0 13.598 0.707783 14.5306 1.69197 14.8666L5 10.0359V3.00003H9.81808L11.1877 1.00003H4C3.44772 1.00003 3 1.44774 3 2.00003V10.05C2.83844 10.0172 2.67123 10 2.5 10C1.11929 10 0 11.1193 0 12.5Z",
    fill: "#8c8f9d"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMusicOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/music-off.73fa165e.svg";
export { ForwardRef as ReactComponent };